import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../../helpers/reselectHelpers';
import {
  CrmSyncIntegrationResourceTypesEnum,
  CrmSyncSourcesEnum,
} from '../../../../../models/api/crmSyncModel';
import {
  CrmSyncSearchOptions,
  searchSalesforceAccountListsAsyncAction,
} from '../../../../../store/data/crmSync/crmSyncActions';
import {SalesforceListsDropdown} from './salesforceListsDropdown';

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  searchSalesforceAccountListsAsync: (query: string, options: CrmSyncSearchOptions) =>
    searchSalesforceAccountListsAsyncAction(
      CrmSyncSourcesEnum.SALESFORCE,
      CrmSyncIntegrationResourceTypesEnum.ACCOUNT,
      query,
      options,
    ),
}));

export const SalesforceListsDropdownContainer = connect(null, mapDispatchToProps)(SalesforceListsDropdown);
